module.exports = __webpack_public_path__ + "static/media/Toilettensitzdesinfektion.70a68e24.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Toilettensitzdesinfektion.png
// module id = 133
// module chunks = 0